import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { saasApi, type SaaSOrganization } from '../../api/saas';

export function OrganizationManagerPage() {
  const [orgs, setOrgs] = useState<SaaSOrganization[]>([]);
  const [error, setError] = useState('');

  useEffect(() => {
    void saasApi.organizations().then(setOrgs).catch((e) => setError(String(e)));
  }, []);

  return (
    <div className="mx-auto max-w-4xl p-6">
      <Link to="/saas" className="text-sm text-slate-600 hover:underline dark:text-slate-400">← Global SaaS Dashboard</Link>
      <h1 className="mt-2 text-2xl font-semibold">Organization Manager</h1>
      {error && <p className="mt-4 text-sm text-red-600">{error}</p>}
      <ul className="mt-4 divide-y rounded-lg border dark:border-slate-700">
        {orgs.map((o) => (
          <li key={o.id} className="px-4 py-3">
            <div className="flex justify-between">
              <span className="font-medium">{o.name}</span>
              <span className="text-sm text-slate-500">{o.tenant_count} tenants</span>
            </div>
            <p className="text-sm text-slate-500">{o.profile?.legal_name} · {o.profile?.country} · {o.status}</p>
          </li>
        ))}
      </ul>
    </div>
  );
}
